"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";

type Item = { q: string; a: string };

/**
 * Pricing-page FAQ accordion. Mirrors the /design#pricing variation: a hairline
 * divider stack, chevron that rotates 180° when open, first item open by default.
 */
export function PricingFaq({ items }: { items: Item[] }) {
  const [open, setOpen] = useState(0);

  return (
    <div className="mx-auto mt-16 max-w-2xl">
      <p className="kicker text-center text-muted-foreground">Pricing questions</p>
      <div className="mt-5 divide-y divide-border border-y hairline-strong">
        {items.map((item, i) => {
          const isOpen = open === i;
          return (
            <div key={item.q}>
              <button
                type="button"
                aria-expanded={isOpen}
                onClick={() => setOpen(isOpen ? -1 : i)}
                className="flex w-full items-center justify-between gap-4 py-4 text-left"
              >
                <span className="text-base font-medium tracking-tight">{item.q}</span>
                <span
                  className="inline-flex size-7 shrink-0 items-center justify-center rounded-full border hairline-strong text-foreground/70 transition-transform"
                  style={{ transform: isOpen ? "rotate(180deg)" : "none" }}
                >
                  <ChevronDown className="size-4" aria-hidden="true" />
                </span>
              </button>
              {isOpen && (
                <div className="overflow-hidden">
                  <p className="pb-4 pr-10 leading-relaxed text-foreground/65">{item.a}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
      <p className="mt-6 text-center text-xs text-muted-foreground">
        Private access — invites rolling out.{" "}
        <a href="/contact" className="text-foreground underline underline-offset-4">
          Talk to us
        </a>{" "}
        about Enterprise.
      </p>
    </div>
  );
}
